import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { InfoDialogComponent } from "../info-dialog/info-dialog.component";
import { CommonService } from '../../../common.service';
import { TeslSchema } from '../../../tesl-schema';
import { LoaderService } from '../../../common/loader/loader.service'


@Component({
  selector: 'app-recommendation-card',
  templateUrl: './recommendation-card.component.html',
  styleUrls: ['./recommendation-card.component.scss']
})
export class RecommendationCardComponent implements OnInit {
  checked = true;
  modify = false;
  percent_slider = 50;
  coverageCost = {
    property:0,
    accident:0,
    driver: {
      range:0,
      noOfDrivers:0
    },
    cargo: 0,
    data: 0
  };

  @Input() coverageDetails;
  @Input() tesl;
  @Input() receiver;
  @Output() updatedCoverage = new EventEmitter();

  constructor(public dialog: MatDialog,public commonService: CommonService, public loaderService: LoaderService) { }

  ngOnInit() {

    CommonService.filer_coverage_values();

    // CommonService.total_filtered_values();
    this.commonService.changeOptions(CommonService.filtered_coverage);
    this.commonService.changeTotalCoverage(CommonService.filtered_total); 
    this.commonService.changeOptions(CommonService.filtered_coverage);
    if(this.coverageDetails.switch == 1){
      this.checked = true;
    }
    else{
      this.checked = false;
    }
    this.percent_slider = this.coverageDetails.slider_value;
  }

  resetState() {
    this.checked = true;
    // this.percent_slider = 50;
  }

  openDialog(id): void {
    const dialogRef = this.dialog.open(InfoDialogComponent, {
      data: { 'id': this.coverageDetails.id }
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }

  modifyCoverage() {
    this.modify = !this.modify;
  }

  updateParent() {
    this.updatedCoverage.emit(this.coverageCost)
    this.modify = false;
  }

  onChange(e, x) 
  {
        if (e.checked == true)
        {
          var flag = 0;
          for(let i=0; i<CommonService.coverage_options_selected.length; i++)
          {
            
            if(CommonService.coverage_options_selected[i] == x)
            {
              flag = 1;
              break;
            }
          }
          if(flag == 0)
          {

            CommonService.coverage_options_selected.push(+x);
            CommonService.coverage_options_selected = CommonService.coverage_options_selected.sort();
          }
          this.coverageDetails.switch = 1;
        } 
        else
        {
          // console.log('unchecked', x);
          var index_x = CommonService.coverage_options_selected.indexOf(+x)
          var splice = CommonService.coverage_options_selected.splice(index_x,1);
          CommonService.coverage_options_selected = CommonService.coverage_options_selected.sort();
          this.coverageDetails.switch = 0;
        }
        //filter the values on user selection basis
        CommonService.filer_coverage_values();

        // CommonService.total_filtered_values();

        //change the values of filtered coverages and change the total of the new filtered list
        this.commonService.changeOptions(CommonService.filtered_coverage);
        this.commonService.changeTotalCoverage(CommonService.filtered_total);
    }

    onChangeSlider(e, id){
      // console.log(e);
      
      var changed_coveraged_value = +(this.coverageDetails.range.min.replace(",","")) + (+(this.coverageDetails.range.max.replace(",","")) - +(this.coverageDetails.range.min.replace(",","")))*e.value/100;
      this.coverageDetails.coverage = changed_coveraged_value; 
      this.coverageDetails.price = changed_coveraged_value * this.coverageDetails.initial_price/(+this.coverageDetails.range.min.replace(",",""));
      CommonService.total_filtered_values();
      this.commonService.changeTotalCoverage(CommonService.filtered_total);
      this.coverageDetails.slider_value = e.value;
    }
    numberToString(value){
      value = value+"";
      value = +value;
      return(this.commaSeperatedNumber(parseFloat(value+"").toFixed(2)+""));
    }

    commaSeperatedNumber(value){
      // console.log(value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");)
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
}
